const helpMessages = {
  '/': {
    title: 'トップページ',
    messages: [
      '参加中のルームに戻ったり、新しく参加するルームを探したりできます。気になるルームを選んで、ルームページへ進みましょう。',
      'ランキングやマイページ、ルームの作成などは、画面上部のメニューから利用できます。',
    ],
  },
  '/login': {
    title: 'ログイン',
    messages: [
      'この画面では、登録済みアカウントでログインできます。',
      '新規登録を行う場合は、登録画面へ移動してください。',
    ],
  },
  '/register': {
    title: '新規登録',
    messages: [
      'この画面では、新しいアカウントを登録できます。',
      '登録済みの方は、ログイン画面へ移動してください。',
    ],
  },
  '/room': {
    title: 'ベットルーム',
    messages: [
      'このルームでは、ラウンドごとに提示される選択肢から結果を予想し、ルームチップをベットします。',
      'ベット受付が始まったら、予想する選択肢とベットするルームチップを決めてください。',
      'ラウンドはオーナーが進行します。ベット受付の開始や結果発表まで、画面の案内に沿ってお待ちください。',
    ],
  },
  ownerCreate: {
    title: 'ルーム作成',
    messages: [
      '予想する内容やベット終了方式など、ルームの進行に必要な項目を設定します。',
      'ルームを作成すると、ルームの運営画面に移動します。',
    ],
  },
  ownerSettings: {
    title: 'ルーム設定',
    messages: [
      '運営中のルームの進行に関する設定を確認・変更できます。',
      '変更内容は画面下部の更新ボタンで保存してください。',
    ],
  },
  '/owner-console': {
    title: 'オーナーコンソール',
    messages: [
      'オーナーコンソールでは、ラウンドの開始から結果確定まで、ルームの進行を操作します。',
      '① ラウンドを開始し、② 参加者の予想を待ちます。',
      '③ 結果を登録します。結果が確定したら、④ 次のラウンドへ進むかルームを終了します。',
      '配信パネルには現在のラウンド状況や予想状況など、参加者向けの情報が表示されます。',
      'OBSなどの配信ソフトに取り込むことで、視聴者へイベント状況をわかりやすく共有できます。',
    ],
  },
  '/owner-console-mobile': {
    title: 'オーナーコンソール',
    messages: [
      'オーナーコンソールでは、ラウンドの開始から結果確定まで、ルームの進行を操作します。',
      '① ラウンドを開始し、② 参加者の予想を待ちます。',
      '③ 結果を登録します。結果が確定したら、④ 次のラウンドへ進むかルームを終了します。',
    ],
  },
  '/mypage': {
    title: 'マイページ',
    messages: [
      'マイページではプロフィールや参加チケットを確認できます。',
      '参加したルームや主催したルームの履歴から、自分の実績を振り返れます。',
      'フォローやライバルの情報も確認でき、自分に関係するユーザーの動きも見返せます。',
    ],
  },
  '/ranking': {
    title: 'ランキング',
    messages: [
      'ランキングではポイントの順位を確認できます。',
      '上位ユーザーの動向を参考にしながら目標を立て、ランキングページからマイページへアクセスできます。',
    ],
  },
};

const normalizeHelpMessageKey = (helpMessageKey) => {
  if (!helpMessageKey) {
    return '/';
  }
  const trimmed = helpMessageKey.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
};

export const getHelpMessageForKey = (helpMessageKey) => {
  const normalizedKey = normalizeHelpMessageKey(helpMessageKey);
  return helpMessages[normalizedKey] ?? null;
};

export default helpMessages;
